import { render, staticRenderFns } from "./UnidadeProfile.vue?vue&type=template&id=b8690d0e"
import script from "./UnidadeProfile.vue?vue&type=script&lang=js"
export * from "./UnidadeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports